export default __webpack_public_path__ + "assets/images/bea208bb04a7c28e698d0588ff423b60.svg";